function AutoSalePage() {
  return <></>;
}

export default AutoSalePage;
